var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlataforma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Plataforma",
    d: "M-1660-3423a1,1,0,0,1-1-1v-1a1,1,0,0,1,1-1h34a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Zm5-3a3.009,3.009,0,0,1-3-3v-15a3.009,3.009,0,0,1,3-3h24a3.009,3.009,0,0,1,3,3l-.015,15a3,3,0,0,1-2.984,3Zm0-3h24v-15h-24Z",
    transform: "translate(1661 3447)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlataforma);
export default __webpack_public_path__ + "static/media/Plataforma.260a3cf8eeda6033f0ca249708a04eee.svg";
export { ForwardRef as ReactComponent };